import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../store';

type IdsInMap = {
  tourIds: string[];
  focusTourIds: string[];
  schoolIds: string[];
  studentIds: string[];
  vehicleIds: string[];
  employeeIds: string[];
  toursLoadedFromUrl: boolean;
};

const initialState: IdsInMap = {
  tourIds: [],
  focusTourIds: [],
  schoolIds: [],
  studentIds: [],
  vehicleIds: [],
  employeeIds: [],
  toursLoadedFromUrl: false,
};

const idsInMapSlice = createSlice({
  name: 'idsInMap',
  initialState,
  reducers: {
    setTourIdsInMap(state, action) {
      state.tourIds = action.payload;
    },
    setFocusTourIdsInMap(state, action) {
      state.focusTourIds = action.payload;
    },
    setSchoolIdsInMap(state, action) {
      state.schoolIds = action.payload;
    },
    setStudentIdsInMap(state, action) {
      state.studentIds = action.payload;
    },
    setVehicleIdsInMap(state, action) {
      state.vehicleIds = action.payload;
    },
    setEmployeeIdsInMap(state, action) {
      state.employeeIds = action.payload;
    },
    setToursLoadedFromUrl(state, action) {
      state.toursLoadedFromUrl = action.payload;
    },
  },
});

export default idsInMapSlice.reducer;

export function setTourIdsInMap(ids: string[]) {
  dispatch(idsInMapSlice.actions.setTourIdsInMap(ids));
}

export function setFocusTourIdsInMap(ids: string[]) {
  dispatch(idsInMapSlice.actions.setFocusTourIdsInMap(ids));
}

export function setSchoolIdsInMap(ids: string[]) {
  dispatch(idsInMapSlice.actions.setSchoolIdsInMap(ids));
}

export function setStudentIdsInMap(ids: string[]) {
  dispatch(idsInMapSlice.actions.setStudentIdsInMap(ids));
}

export function setVehicleIdsInMap(ids: string[]) {
  dispatch(idsInMapSlice.actions.setVehicleIdsInMap(ids));
}

export function setEmployeeIdsInMap(ids: string[]) {
  dispatch(idsInMapSlice.actions.setEmployeeIdsInMap(ids));
}

export function setToursLoadedFromUrl(loaded: boolean) {
  dispatch(idsInMapSlice.actions.setToursLoadedFromUrl(loaded));
}
